import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { clone, cloneDeep, cloneDeepWith, first, isEqual } from "lodash";
import {
  assignVersionToList,
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../mdae-framework";
import { GET_MY_TASK_LIST } from "../services/get-my-task-list";
export const defaultMyTaskDrawerConfig = {
  isOpened: true,
  isVisible: true,
};
export const defaultMyTaskWidgetConfig = {
  totalCollapsedDrawers: 0,
};
const initialState = {
  isLoading: false,
  myTaskList: {},
  myTaskListForDataGrid: [],
  filteredMyTaskList: {},
  isGroupByApplied: false,
  myTaskDrawerConfig: {},
  myTaskWidgetConfig: {},
  myTaskDrawerScrollConfig: {},
  isMyTasksListLoading: true,
  isCompleteTaskToastVisibleForCardView:false
};
export const SET_MY_TASK_DRAWER_CONFIG_OPTIONS =
  "SET_MY_TASK_DRAWER_CONFIG_OPTIONS";
export const SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS =
  "SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS";
export const SET_MY_TASK_WIDGET_CONFIG_OPTIONS =
  "SET_MY_TASK_WIDGET_CONFIG_OPTIONS";
export const SET_FILTERED_MY_TASK_LIST = "SET_FILTERED_MY_TASK_LIST";
export const SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST =
  "SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST";
export const SET_IS_REFRESH_SCROLL_POSITION = "SET_IS_REFRESH_SCROLL_POSITION";
export const TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW = "TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW";
export const SET_CARD_TASK_DATA = "SET_CARD_TASK_DATA";
export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_MY_TASK_LIST)(action)) {
        return { ...state, isMyTasksListLoading: true };
      }
      if (isAsyncComplete(GET_MY_TASK_LIST)(action)) {
        newState = cloneDeep(state);
        const response = action.response;
        if (response.myTaskList?.length > 0) {
          response.myTaskList = assignVersionToList(response.myTaskList);
          const currentWidgetId = (first(response.myTaskList) as any)
            .myTaskWidgetId;
          newState.myTaskList[currentWidgetId] = response.myTaskList;
          newState.myTaskListForDataGrid = response.myTaskList;
          if (newState.myTaskDrawerConfig) {
            for (var prop in newState.myTaskDrawerConfig) {
              newState.myTaskDrawerConfig[prop].refreshScrollPosition = true;
            }
          }
        }
        return { ...newState, isMyTasksListLoading: false };
      }
      return state;
    case SET_IS_REFRESH_SCROLL_POSITION:
      newState = cloneDeep(state);
      newState.refreshScrollPosition = action.data.refreshScrollPosition;
      return newState;
    case SET_FILTERED_MY_TASK_LIST:
      newState = cloneDeep(state);
      newState.filteredMyTaskList = newState.filteredMyTaskList
        ? newState.filteredMyTaskList
        : {};
      newState.filteredMyTaskList[action.data?.myTaskWidgetId] =
        action.data?.filteredMyTaskList;
      return newState;
    case SET_MY_TASK_DRAWER_CONFIG_OPTIONS:
      newState = cloneDeep(state);
      let myTaskDrawerConfig =
        newState.myTaskDrawerConfig[action.data.myTaskDrawerId];
      myTaskDrawerConfig = myTaskDrawerConfig ? myTaskDrawerConfig : {};
      for (var prop in action.data) {
        myTaskDrawerConfig[prop] = action.data[prop];
      }
      newState.myTaskDrawerConfig[
        action.data.myTaskDrawerId
      ] = myTaskDrawerConfig;
      return newState;

    case SET_MY_TASK_DRAWER_SCROLL_CONFIG_OPTIONS:
      newState = cloneDeep(state);
      if (!action.data.isNotRefresh) {
        let myTaskDrawerScrollConfig =
          newState.myTaskDrawerScrollConfig[action.data.myTaskDrawerId];
        myTaskDrawerScrollConfig = myTaskDrawerScrollConfig
          ? myTaskDrawerScrollConfig
          : {};
        for (var prop in action.data) {
          myTaskDrawerScrollConfig[prop] = action.data[prop];
        }
        newState.myTaskDrawerScrollConfig[
          action.data.myTaskDrawerId
        ] = myTaskDrawerScrollConfig;
      } else {
        newState.myTaskDrawerConfig[
          action.data.myTaskDrawerId
        ].refreshScrollPosition = false;
      }

      return newState;
    case SET_MY_TASK_WIDGET_CONFIG_OPTIONS:
      newState = cloneDeep(state);
      let myTaskWidgetConfig =
        newState.myTaskWidgetConfig[action.data.myTaskWidgetId];
      myTaskWidgetConfig = myTaskWidgetConfig ? myTaskWidgetConfig : {};
      for (var prop in action.data) {
        myTaskWidgetConfig[prop] = action.data[prop];
      }
      newState.myTaskWidgetConfig[
        action.data.myTaskWidgetId
      ] = myTaskWidgetConfig;
      return newState;
    case SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST:
      newState = cloneDeep(state);
      const currentWidgetId = action.data.myTaskWidgetId;
      newState.myTaskList[currentWidgetId] = assignVersionToList(action.data.myTaskList);
      return newState;
    case TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW:
    case SET_CARD_TASK_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}
